import React from "react";
import styled from "styled-components";


const HeroContainer = styled.div`
  padding: 70px 0 0 0;
  background: linear-gradient( rgba(0, 0, 0, ${props => props.darkness ? props.darkness : ""}),
   rgba(0, 0, 0, ${props => props.darkness ? props.darkness : ""}) ),
   url(${props => props.bg ? props.bg : ""});
  min-height: ${props => props.h ? props.h : props.h};
  background-size: cover;
  background-repeat: no-repeat;
`

const HeroText = styled.div`
  width: 50%;
  position: absolute;
  top: 25vh;
  left: 5vw;
  color: #fff;
  * {
   font-weight: 700;
   font-family: "Open Sans";
  }
  hr {
    width: 80%;
    background-color: #CE0101;
    height: 20px;
    margin: 1.5rem 0 0 0;
  }
`

const PageHero = (props) => {


  return (
    <HeroContainer {...props}>
      <HeroText>
        {props.children}
        <hr/>
      </HeroText>
    </HeroContainer>
  )
}

export default PageHero;